import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AnimalModel } from '../../models/animal.model';
import { getDocumentFileMeta } from '../../animal-details-documents/document-file-type.util';
import { MedicalFileService } from '../../services/medical-file.service';
import { MedicalFile } from '../../states/medical/animal-medical.selectors';

/** Vorschau eines Anhangs: PDF/Text im iframe, Bild und Video über die Mediathek-Container. */
@Component({
  selector: 'app-medical-file-preview',
  templateUrl: './medical-file-preview.component.html',
  standalone: false
})
export class MedicalFilePreviewComponent implements OnChanges {
  @Input() file: MedicalFile | null = null;
  @Input() animal: AnimalModel | null = null;
  @Output() closed = new EventEmitter<void>();

  visible = false;
  previewUrl: SafeResourceUrl | null = null;

  constructor(
    private readonly _fileService: MedicalFileService,
    private readonly _sanitizer: DomSanitizer
  ) {}

  ngOnChanges(): void {
    this.visible = !!this.file;
    const url = this.file && this._fileService.isPreviewableDocument(this.file) ? this._fileService.fileUrl(this.file) : null;
    this.previewUrl = url ? this._sanitizer.bypassSecurityTrustResourceUrl(url) : null;
  }

  get icon(): string {
    if (!this.file) return 'pi pi-file';
    return getDocumentFileMeta(this.file.name).icon + ' ' + getDocumentFileMeta(this.file.name).colorClass;
  }

  download(): void {
    if (this.file) this._fileService.download(this.file);
  }

  onHide(): void {
    this.visible = false;
    this.closed.emit();
  }
}
